import { Component, OnInit } from '@angular/core';
import { BookingService } from '../booking/booking.service';


@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})


export class ContactUsComponent implements OnInit {

  constructor(public booking: BookingService) { }

  ngOnInit(): void {
  }

}
